import { useState } from 'react';

export const IS_USA_PERSON = 'is_usa_person';
export const HAS_GREEN_CARD = 'has_green_card';
export const HAS_USA_TAXES = 'has_usa_taxes';
export const USA_TAXES_TYPE = 'usa_taxes_type';
export const USA_TAXES_TYPE_DESC = 'usa_taxes_type_desc';
export const STREET_INFO = 'street_info';
export const COUNTRY_INFO = 'country_info';
export const ACCOUNT_NUMS = 'account_nums';
export const TIN = 'TIN';
export const PEP = 'pep';
export const PEP_DESC = 'pep_desc';
export const PRIVACY_AGREED = 'privacy_agreed';
export const ACTIVIRY_SUBJ = 'activity_subject';
export const ACTIVIRY_SUBJ_COMMENT = 'activity_subject_comment';
export const OTHER_ASSETS = 'other_assets'
export const EMP_STATUS = 'emp_status';
export const CLIENT_TYPE = 'client_type';
export const ASSETS = 'assets';
export const INCOME_SOURCE = 'income_source';
export const MONTHLY_TURNOVER = 'monthly_turnover';
export const JOB = 'job';
export const MONTHLY_INCOME = 'monthly_income';
export const JOB_POSITION = 'job_position';
export const JOB_START_DATE = 'job_start_date';
export const ACCOUNT_PURPOSES = 'accountPurposes';
export const SELECTED_COUNTRY_FROM = 'selectedCountriesFrom';
export const SELECTED_COUNTRY_TO = 'selectedCountriesTo';
export const CASH_TURNOVER_ID = 'cashTurnoverId'
export const MONEY_SOURCES = 'moneySources'
export const WEALTH_SOURCES = 'wealthSources'
export const WHERE_YOU_HAVE_BANK_ACCOUNTS = 'whereYouHaveBankAccounts'
export const PLEASE_SPECIFY_INCOME_SOURCE = 'please_specify_income_source'
export const PLEASE_SPECIFY_WEALTH = 'please_specify_wealth'
export const PLEASE_SPECIFY_BANKS = 'please_specify_banks'
export const CONFIRM_KYC = 'confirm_KYC'
export const CATEGORY_OF_POLITICALY_EXPOSED = 'pepCategory'
export const INFORMATION_ABOUT_RELATED_PEP = 'information_about_related_pep'
export const INFORMATION_ON_CONTERPARTIES = 'Information_on_counterparties'
export const SPECIFY_INCOME_SOURCE = 'specify_income_source_for_general_pi_form'


const initialValues = {
  [ACCOUNT_PURPOSES]: [],
  [SELECTED_COUNTRY_FROM]: null,
  [SELECTED_COUNTRY_TO]: null,
  [INCOME_SOURCE]: '',
  [MONTHLY_INCOME]: '',
  [MONTHLY_TURNOVER]: '',
  [JOB]: '',
  [JOB_POSITION]: '',
  [JOB_START_DATE]: '',
  [IS_USA_PERSON]: 'no',
  [HAS_GREEN_CARD]: 'no',
  [HAS_USA_TAXES]: '',
  [USA_TAXES_TYPE]: '',
  [USA_TAXES_TYPE_DESC]: '',
  [STREET_INFO]: '',
  [COUNTRY_INFO]: '',
  [ACCOUNT_NUMS]: '',
  [TIN]: '',
  [PEP]: 'no',
  [CATEGORY_OF_POLITICALY_EXPOSED]: [],
  [INFORMATION_ABOUT_RELATED_PEP]: '',
  [PEP_DESC]: '',
  [PRIVACY_AGREED]: false,
  [EMP_STATUS]: '',
  [CLIENT_TYPE]: '',
  [ASSETS]: [],
  [ACTIVIRY_SUBJ]: '',
  [ACTIVIRY_SUBJ_COMMENT]: '',
  [OTHER_ASSETS]: '',
  [CASH_TURNOVER_ID]: '',
  [MONEY_SOURCES]: [],
  [WEALTH_SOURCES]: [],
  [WHERE_YOU_HAVE_BANK_ACCOUNTS]: [],
  [PLEASE_SPECIFY_INCOME_SOURCE]: '',
  [PLEASE_SPECIFY_WEALTH]: '',
  [PLEASE_SPECIFY_BANKS]: '',
  [CONFIRM_KYC]: false,
  [INFORMATION_ON_CONTERPARTIES]: ''
};

function useStepFourValues() {
  const [stepFourValues, setStepFourValues] = useState(initialValues);
  return { stepFourValues, setStepFourValues };
}

export default useStepFourValues;
